import { GlobalStyle } from "./styles";
import { Route, Routes, useNavigate } from "react-router";
import { LanguageCode, useTranslation } from "./lang/TranslationContext";
import { ThemeProvider } from "styled-components";
import { lightTheme } from "./styles/theme";
import { Toaster } from "react-hot-toast";
import { ROUTES } from "./constants/routes";
// import { Authentication } from './pages/Authentication';
// import { ProtectedRoute } from './utils/ProtectedRoute';
// import { ChooseSubscription } from './pages/ChooseSubscription';
// import { FinalizeSubscription } from './pages/FinalizeSubscription';
import { Main } from "./pages/Main";
import { useEffect } from "react";
import { LANG_OPTIONS } from "./components/Select/LanguageSelect";
// import { SeoUpdater } from './seo/SeoUpdater';

function App() {
  const { switchLanguage } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    const langFromUrl = window.location.pathname.split("/")[1];

    if (langFromUrl && LANG_OPTIONS.includes(langFromUrl)) {
      switchLanguage(langFromUrl as LanguageCode);
      navigate("/", { replace: true });
    } else {
      navigate("/", { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ThemeProvider theme={lightTheme as typeof lightTheme}>
      {/* <SeoUpdater lang={language} /> */}
      <Toaster
        position="top-right"
        toastOptions={{
          success: {
            style: {
              borderRadius: "20px",
              padding: "12px",
              color: "#141d1b",
            },
            iconTheme: {
              primary: "#0B835C",
              secondary: "#ffffff",
            },
          },
          error: {
            style: {
              borderRadius: "20px",
              padding: "12px",
              color: "#141d1b",
            },
            iconTheme: {
              primary: "#AA3030",
              secondary: "#ffffff",
            },
          },
        }}
      />
      <GlobalStyle />

      <div className="App">
        <Routes>
          {/* <Route
								path={ROUTES.signup}
								element={<Authentication type="signup" />}
							/>
							<Route
								path={ROUTES.otp}
								element={<Authentication type="otp" />}
							/> */}
          {/* <Route
						path={ROUTES.chooseSubscription}
						element={<ProtectedRoute component={<ChooseSubscription />} />}
					/>
					<Route
						path={ROUTES.finalizeSubscription}
						element={<ProtectedRoute component={<FinalizeSubscription />} />}
					/> */}
          <Route path={ROUTES.home} element={<Main />} />
          {/* <Route path="*" element={<Navigate to="/" replace />} /> */}
        </Routes>
      </div>
    </ThemeProvider>
  );
}

export default App;
